import { observable, reaction } from "mobx";
import Helper from "../../../../../module/Helper";
import PTSFile from "../../../common/PTSFile";
import Validatable from "../../../common/Validatable";
import TaskSubData from "../../DesignTaskSubData";
import Decimal from "decimal.js";

export default class Synthesis3 extends TaskSubData {
    @observable origProbeVol?: number;
    @observable finalAmount?: number;
    @observable probeID?: string;
    @observable probeName?: string;
    @observable probeConc?: number;
    @observable boxNumber?: string;
    @observable sdContents?: string[];
    @observable dilutionFactor?: number;
    @observable probeTapeStationFile?: PTSFile;
    @observable poolingExcelFile?: PTSFile;
    sdContentsError?: string[];

    constructor() {
        super();
        this.probeTapeStationFile = new PTSFile();
        this.poolingExcelFile = new PTSFile();
        this.dilutionFactor = 100;
        this.sdContents = [];
        this.sdContentsError = [];
    }

    setfinalAmount1 = reaction(
        () => this.probeConc,
        (val) => {
            if (val && this.dilutionFactor && this.origProbeVol) {
                this.finalAmount = new Decimal(val).times(new Decimal(this.dilutionFactor)).times(new Decimal(this.origProbeVol)).toNumber();
            } else {
                this.finalAmount = null;
            }
        }
    );

    setfinalAmount2 = reaction(
        () => this.dilutionFactor,
        (val) => {
            if (val && this.probeConc && this.origProbeVol) {
                this.finalAmount = new Decimal(val).times(new Decimal(this.probeConc)).times(new Decimal(this.origProbeVol)).toNumber();
            } else {
                this.finalAmount = null;
            }
        }
    );

    setfinalAmount3 = reaction(
        () => this.origProbeVol,
        (val) => {
            if (val && this.dilutionFactor && this.probeConc) {
                this.finalAmount = new Decimal(val).times(new Decimal(this.dilutionFactor)).times(new Decimal(this.probeConc)).toNumber();
            } else {
                this.finalAmount = null;
            }
        }
    );

    // override
    validateSelf(): void {
        const probeIDReg = /^[a-zA-Z0-9]{4}PD\d{3}-V\d+\.\d+\.\d+$/;
        if (!this.probeID) {
            this.setErrorTextByName("probeID", Validatable.errorTexts.needValue);
        } else if (!Helper.checkRegex(this.probeID, probeIDReg)) {
            this.setErrorTextByName("probeID", `${Validatable.errorTexts.badFormat} -> 포맷: XXXXPD###-Vn.n.n`);
        }
        if (!this.probeName) {
            this.setErrorTextByName("probeName", Validatable.errorTexts.needValue);
        }
        // else if (!Helper.checkRegex(this.probeName, /^[0-9a-zA-Z-_+#]+$/)) {
        //     this.setErrorTextByName('probeName', `${Validatable.errorTexts.badFormat} -> 포맷: 영문, 숫자, + , # , - , _ `);
        // }
        if (!this.probeConc) {
            this.setErrorTextByName("probeConc", Validatable.errorTexts.needValue);
        } else if (this.probeConc < 0) {
            this.setErrorTextByName("probeConc", Validatable.errorTexts.positive);
        }
        if (!this.dilutionFactor) {
            this.setErrorTextByName("dilutionFactor", Validatable.errorTexts.needValue);
        } else if (this.dilutionFactor < 0) {
            this.setErrorTextByName("dilutionFactor", Validatable.errorTexts.positive);
        }
        if (!this.origProbeVol) {
            this.setErrorTextByName("origProbeVol", Validatable.errorTexts.needValue);
        } else if (!Helper.checkRegex(this.origProbeVol.toString(), /^\d*(\.\d{1})?$/)) {
            this.setErrorTextByName("origProbeVol", `${Validatable.errorTexts.badFormat} -> 포맷: #.#`);
        }
        if (!this.finalAmount) {
            this.setErrorTextByName("finalAmount", Validatable.errorTexts.needValue);
        } else if (!Helper.checkRegex(this.finalAmount.toString(), /^\d*(\.\d{1})?$/)) {
            this.setErrorTextByName("finalAmount", `${Validatable.errorTexts.badFormat} -> 포맷: #.#`);
        }
        if (!this.boxNumber) {
            this.setErrorTextByName("boxNumber", Validatable.errorTexts.needValue);
        }
        // else if (this.boxNumber <= 0) {
        //     this.setErrorTextByName('boxNumber', Validatable.errorTexts.positiveNumber);
        // }
        if (!this.probeTapeStationFile.name) {
            this.setErrorTextByName("probeTapeStationFile", Validatable.errorTexts.fileValid);
        }
        if (!this.poolingExcelFile.name) {
            this.setErrorTextByName("poolingExcelFile", Validatable.errorTexts.fileValid);
        }
        if (this.sdContents.length < 1) {
            this.setErrorTextByName("sdContents", "입력값이 없거나 적용 되지 않았습니다.");
        } else if (typeof this.sdContents !== "undefined" && this.sdContents.length > 0) {
            const reg1 = /^[a-zA-Z0-9]{4}SD\d{3}-\d+\.\d+-\d+$/;
            const reg2 = /^[a-zA-Z0-9]{4}PD\d{3}-V\d+(\.\d+){0,2}$/;
            for (let index in this.sdContents) {
                if (!Helper.checkRegex(this.sdContents[index], reg1) && !Helper.checkRegex(this.sdContents[index], reg2)) {
                    this.setErrorTextByName("sdContents", "");
                    this.sdContentsError[index] = `${Validatable.errorTexts.badFormat} -> 포맷: XXXXSD###-n.n-n or XXXXPD###-Vn.n.n`;
                } else {
                    this.sdContentsError[index] = "";
                }
            }
        }
    }
}
